import '.l{position:absolute;}.ssr-plugin'
import '.br{top:calc(100%);}.ssr-plugin'
/* eslint-disable react-refresh/only-export-components */
import { useState, Children, type PropsWithChildren, useCallback } from 'react'
import { styled, type Style } from 'inlines'
import { Text } from '../typography/Text'

const Group = ({ children }: PropsWithChildren) => {
  return (
    <div
      style={{
        justifyContent: 'flex-start',
        alignItems: 'center',
        display: 'inline-flex',
      }}
    >
      {Children.map(children, (child) => child)}
    </div>
  )
}

export type TabProps = {
  children?: JSX.Element
  label: string
}

const Tab = ({ children, label }: TabProps) => {
  const [subMenuShown, setSubMenuShown] = useState(false)
  const tabStyle: Style = {
    padding: 24,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    display: 'flex',
    cursor: 'default',
    borderBottom: '2px transparent solid',
    userSelect: 'none',
    '&:hover': { borderBottom: '2px var(--primary-blue) solid' },
  }

  const textStyle: Style = {
    wordWrap: 'break-word',
    color: 'var(--primary-blue)',
    '&:hover': {
      color: 'var(--primary-blue)',
    },
  }

  const renderSubMenu = useCallback(() => {
    if (!children || !subMenuShown) {
      return null
    }
    return (
      <div className="l br"
      >
        {children}
      </div>
    )
  }, [subMenuShown, children])

  return (
    <styled.div
      style={tabStyle}
      onMouseOver={() => setSubMenuShown(true)}
      onMouseOut={() => setSubMenuShown(false)}
    >
      <Text.Medium style={textStyle}>{label}</Text.Medium>
      {renderSubMenu()}
    </styled.div>
  )
}

export const HoverTabs = {
  Group,
  Tab,
}
